module.exports = __webpack_public_path__ + "img/dog-cut.c4b51d3a.jpg";